import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {FiltersDTO} from "../domain/dtos/filters.dto";
import {Entity} from "../domain/entities/entity";
import {Filters} from "../domain/entities/filters.entity";
import {TransformerInterface} from "./transformerInterface";

@injectable()
@transformer({
    source: Filters,
    target: `dto`
})
export class FiltersToDtoTransformer implements TransformerInterface<Partial<FiltersDTO>, Filters> {

    public transform(filters: Filters): Promise<Partial<FiltersDTO>> {
        const dto: Partial<FiltersDTO> = {
            uid: filters.uid
        };

        if (filters.board instanceof Entity) {
            dto.board = filters.board.uid;
        }

        if (filters.creator instanceof Entity) {
            dto.creator = filters.creator.uid;
        }

        if (Array.isArray(filters.assignees) && filters.assignees.length > 0) {
            dto.assignees = filters.assignees.map(a => a.uid);
        }

        if (filters.issueType instanceof Entity) {
            dto.issueType = filters.issueType.uid;
        }

        if (Array.isArray(filters.keywords) && filters.keywords.length > 0) {
            dto.keywords = filters.keywords.map(k => k.uid);
        }

        if (filters.issueStatus instanceof Entity) {
            dto.issueStatus = [filters.issueStatus.uid];
        }

        return Promise.resolve(dto);
    }

}